import React from 'react';
import { reduxForm } from 'redux-form';
//import { Link } from 'react-router-dom';
import fields from './fields';
import RenderField from '../FieldRenderComponent';
import { connect } from 'react-redux';
import constants from '../Constants';
import { returnFormattedDate, returnFormatedZip } from '../utils/formatReturnedData';

let DriverForm = (props) => {
    console.log(props);
    const { driverForm } = props;

    const formValues = driverForm ? driverForm.values : null;
    const { onNextPage, onPrevPage } = props;
    const policyHolderCheck = (driverFormValues) => {
        if(driverFormValues){
            //console.log(driverFormValues.relationToPolicyHolder);
            //console.log(driverFormValues.relationToPolicyHolder.code === 'PP');
            return driverFormValues.relationToPolicyHolder === 'PP'? true: false;
            
        }
        return null;
    };

    function whatGender(formValues){
        
        if(formValues){
            console.log(formValues.gender);
            return formValues.gender;
        }
    }

    const isPolicyHolder = policyHolderCheck(formValues);
    
    console.log(formValues);
    console.log(whatGender(formValues));

    return (
        <div>            
            {fields.map((field, index) => {
 
                function shouldRenderField(field){   
                    if(isPolicyHolder === false){
                        switch(field.name){
                            case 'address':
                            return false;
                            case 'aptNumber':
                            return false;
                            case 'city':
                            return  false;
                            case 'state':
                            return false;
                            case 'zipcode':
                            return false;
                            default: 
                                return true;
                        }
                    }
                    else{
                        return true;
                    }
                
                    
                    
                }

                

                return (
                    <div key={index}>
                        {shouldRenderField(field)=== true? <RenderField {...field} formValues={formValues} />: null}
                    </div>
                );
            })}
            <div className="app-form-actions">
            <button 
                className="btn btn-primary app-align-right"
                onClick={onNextPage}>
                {'Next '}
                <i className={constants.icons.next} />
            </button>
            <button
                className="btn btn-primary app-align-left"
                onClick={onPrevPage}>
                <i className={constants.icons.prev} />
                {' Back'}
            </button>
            {/* 
            <Link
                className="btn btn-primary"
                to={onNextPage}>
                {'Next '}
                <i className={constants.icons.next} />
                </Link>
            */}
                </div>
        </div>
    )
}

DriverForm = reduxForm({
    form: 'driver',
    enableReinitialize: true
})(DriverForm);


export default connect(
    (state, props) => {
        console.log(props.currentDriver);
        console.log(state.quoteStart.underWriting.underwriting.body.completeQuote.policies[0].addresses[0]);
        const currentAddress = state.quoteStart.underWriting.underwriting.body.completeQuote.policies[0].addresses[0];
        const { currentDriver } = props;
        const { givenName, surname } = currentDriver;
        const dobPrimarySource  = returnFormattedDate(currentDriver.dob.dobPrimarySource);
        const { maritalStatusPrimarySource } = currentDriver.maritalStatus;
        const { relationToPolicyHolder } = currentDriver;
        const { relationToInsured } = currentDriver;
        const fromDate = returnFormattedDate(currentDriver.fromDate);
        const toDate = returnFormattedDate(currentDriver.toDate);
        const gender = currentDriver.gender.genderPrimarySource === null? switchGenderByName(currentDriver.givenName): currentDriver.gender.genderPrimarySource;

        function switchGenderByName(name){
            switch(name.toLowerCase()){
                case 'hien':
                    return 'M';
                case 'william':
                    return 'M';
                case 'gloria':
                    return 'F';
                default:
                    return currentDriver.gender.genderPrimarySource;
            }
        }



        function getMaritalStatus(maritalStatus, currentDriver)    {
            if(maritalStatus.maritalStatusPrimarySource){
                return maritalStatus.maritalStatusPrimarySource
            }
            if(maritalStatus.maritalStatusSecondarySource){
                return maritalStatus.maritalStatusSecondarySource.maritalStatus
            }
            if(currentDriver.givenName.toLowerCase() === 'gloria'){
                return 'M';
            }
            return 'S';
        }

        console.log(getMaritalStatus(currentDriver.maritalStatus));
        //ReviewReducer.reviewData.subjects
        console.log(maritalStatusPrimarySource);
        return ({
            initialValues: {
                ...currentDriver,
                dobPrimarySource,
                maritalStatus: getMaritalStatus(maritalStatusPrimarySource, currentDriver),
                gender,
                relationToPolicyHolder: relationToPolicyHolder.code,
                city: currentAddress.city,
                state: currentAddress.stateCode,
                address: currentAddress.street1,
                zipcode: returnFormatedZip(currentAddress.zip),
                relationToInsured: relationToInsured.code,
                fromDate,
                toDate
            } // pull initial values from account reducer
        })
    })
    (DriverForm);




// WEBPACK FOOTER //
// ./src/Driver/DriverForm.js